export interface ProjectExplorerDocumentSortItem {
  id: string;
  title: string;
  pinned?: boolean;
}

export function sortProjectExplorerDocuments<T extends ProjectExplorerDocumentSortItem>(
  documents: T[],
  mainDocumentId: string | null | undefined
): T[] {
  return [...documents].sort((a, b) => {
    const aIsMain = a.id === mainDocumentId;
    const bIsMain = b.id === mainDocumentId;
    if (aIsMain !== bIsMain) {
      return aIsMain ? -1 : 1;
    }

    const aIsPinned = !!a.pinned;
    const bIsPinned = !!b.pinned;
    if (aIsPinned !== bIsPinned) {
      return aIsPinned ? -1 : 1;
    }

    return a.title.localeCompare(b.title);
  });
}
